// accordions js start
function faq_taggol() {
  const accordions = document.querySelectorAll("[js-acc-item]");
  const openAccordion = (accordion) => {
    const content = accordion.querySelector("[js-acc-single-content]");
    accordion.classList.add("active");
    content.style.maxHeight = 'max-content';
  };
  
  const closeAccordion = (accordion) => {
    const content = accordion.querySelector("[js-acc-single-content]");
    accordion.classList.remove("active");
    if(content){
      content.style.maxHeight = null;
    }
  };
  
  accordions.forEach((accordion) => {
    const intro = accordion.querySelector("[js-acc-single-trigger]");
    const content = accordion.querySelector("[js-acc-single-content]");
    if(intro){
        intro.onclick = (e) => {
          if (content.style.maxHeight) {
            closeAccordion(accordion);
          } else {
            accordions.forEach((accordion) => closeAccordion(accordion));
            openAccordion(e.target.closest('[js-acc-item]'));
          }
        };
    }
  });   
}
// accordions js end
(function() {
  faq_taggol();




  const scrollBtn = document.querySelector('.template-collection .coll-button .button.scroll-newsletter');

  if (scrollBtn) {
    scrollBtn.addEventListener('click', function (e) {
      e.preventDefault();


      // Scroll to newsletter section
      const target = document.querySelector('.shopify-section.shopify-section-group-footer-group.newsltter-section');

      if (target) {
        target.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }
    });
  }





})();

// autosize
function autosize() {
    const textareas = document.querySelectorAll('.autosize');

    textareas.forEach(textarea => {
        textarea.setAttribute('rows', 4);
        resize(textarea);

        textarea.addEventListener('input', () => resize(textarea));
    });

    function resize(textarea) {
        textarea.style.height = '120px';
        textarea.style.height = textarea.scrollHeight + 'px';
    }
}

autosize();

//Newsletter popup js
document.addEventListener('DOMContentLoaded', function () {
  const popup = document.getElementById('NewsletterPopup');
  if (localStorage.getItem("newsletterSubscribed") === "true") {
    closePopup();
  }

  if (!popup) return;

  const body = document.body;
  const BODY_CLASS = 'overflow-hidden';

  const COOKIE_NAME = 'newsletter_popup_closed';
  const COOKIE_DAYS = 1;

  function setCookie(name, value, days) {
    const date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    document.cookie = name + "=" + value + "; expires=" + date.toUTCString() + "; path=/";
  }

  function getCookie(name) {
    const cookies = document.cookie.split('; ');
    for (let i = 0; i < cookies.length; i++) {
      const parts = cookies[i].split('=');
      if (parts[0] === name) {
        return parts[1];
      }
    }
    return null;
  }

  function openPopup() {
    popup.classList.add('active');
    body.classList.add(BODY_CLASS);
  }

  function closePopup() {
    popup.classList.remove('active');
    body.classList.remove(BODY_CLASS);
    setCookie(COOKIE_NAME, 'true', COOKIE_DAYS);
  }

  if (!getCookie(COOKIE_NAME)) {
    setTimeout(() => {
      openPopup();
    }, 2000);
  }

  popup.querySelector('.newsletter-popup__close')
    .addEventListener('click', closePopup);

  popup.querySelector('.newsletter-popup__overlay')
    .addEventListener('click', closePopup);

  document.addEventListener('click', function (e) {
    if (
      popup.classList.contains('active') &&
      !popup.querySelector('.newsletter-popup__content').contains(e.target)
    ) {
      closePopup();
    }
  });
});

//end Newsletter popup js

//collection variant option
document.addEventListener('click', function (e) {
  const variantBtn = e.target.closest('.variant-option');
  if (!variantBtn) return;
  e.preventDefault();
  e.stopPropagation();

  const wrapper = variantBtn.closest('.product-variants');
  const card = variantBtn.closest('.card-wrapper');
  const hiddenInput = card.querySelector('.selected-variant-id');

  wrapper.querySelectorAll('.variant-option').forEach(btn => {
    btn.classList.remove('is-active');
  });
  variantBtn.classList.add('is-active');
  hiddenInput.value = variantBtn.dataset.variantId;
});

//cross cell product
function initRelatedProductsSwiper() {
  const swipers = document.querySelectorAll('.related-products-swiper');

  swipers.forEach((swiperEl) => {
    if (swiperEl.classList.contains('swiper-initialized')) return;

    new Swiper(swiperEl, {
      slidesPerView: 1,
      spaceBetween: 16,
      speed: 600,
      loop: false,
      pagination: {
        el: swiperEl.querySelector('.swiper-pagination'),
        clickable: true,
      },
      keyboard: {
        enabled: true,
        onlyInViewport: true,
      },
      breakpoints: {
        640: {
          slidesPerView: 1
          ,
        },
        990: {
          slidesPerView: 1,
        },
      },
    });
  });
}

document.addEventListener('DOMContentLoaded', initRelatedProductsSwiper);
document.addEventListener('shopify:section:load', initRelatedProductsSwiper);

//menga menu image/product hover
document.addEventListener('DOMContentLoaded', function () {

  document.querySelectorAll('.mega-menu').forEach(megaMenu => {

    const childLinks = megaMenu.querySelectorAll('.mega-child-link');

    function showGrandchildren(childHandle) {
      megaMenu.querySelectorAll('[data-grandchild]').forEach(el => {
        el.style.display = el.dataset.grandchild === childHandle ? 'block' : 'none';
      });
    }

    function showProducts(grandHandle) {
      megaMenu.querySelectorAll('[data-products]').forEach(el => {
        el.style.display = el.dataset.products === grandHandle ? 'block' : 'none';
      });

      if (typeof initSwiper === 'function') {
        initSwiper();
      }
    }

    function activateGrandchild(link) {
      const handle = link.dataset.handle;

      megaMenu.querySelectorAll('.mega-menu__link--grandchild')
        .forEach(l => l.classList.remove('active'));

      link.classList.add('active');

      showProducts(handle);
    }

    function activateChild(link) {
      const childHandle = link.dataset.child;

      childLinks.forEach(l => l.classList.remove('mega-menu__link--active'));
      link.classList.add('mega-menu__link--active');

      showGrandchildren(childHandle);

      const firstGrand = megaMenu.querySelector(
        `[data-grandchild="${childHandle}"] .mega-menu__link--grandchild`
      );

      if (firstGrand) {
        activateGrandchild(firstGrand);
      }
    }

    childLinks.forEach(link => {
      link.addEventListener('mouseenter', function () {
        activateChild(this);
      });

      link.addEventListener('click', function () {
        activateChild(this);
      });
    });

    megaMenu.querySelectorAll('.mega-menu__link--grandchild').forEach(link => {
      link.addEventListener('mouseenter', function () {
        activateGrandchild(this);
      });
    });

    if (childLinks.length) {
      activateChild(childLinks[0]);
    }

  });

});

//megamenu product swiper
function initSwiper() {
  document.querySelectorAll('.mega-products.swiper').forEach(slider => {
    if (slider.swiper) return;

    new Swiper(slider, {
      slidesPerView: 3,
      spaceBetween: 10,
      navigation: {
        nextEl: slider.querySelector('.swiper-button-next'),
        prevEl: slider.querySelector('.swiper-button-prev'),
      }
    });
  });
}

//tab Featured collection
document.addEventListener("DOMContentLoaded", function () {
  const tabNavItems = document.querySelectorAll(".tab-nav-title");
  const tabContents = document.querySelectorAll(".tabs-content-wrapper");

  if (tabNavItems.length && tabContents.length) {
    tabNavItems[0].classList.add("active");
    tabContents[0].style.display = "block";
    for (let i = 1; i < tabContents.length; i++) {
      tabContents[i].style.display = "none";
    }
    tabNavItems.forEach((tab, index) => {
      const link = tab.querySelector("a");
      if (link) {
        link.addEventListener("click", function (e) {
          e.preventDefault();
          tabNavItems.forEach(t => {
            t.classList.remove("active");
          });
          tabContents.forEach(content => content.style.display = "none");
          tab.classList.add("active");
          if (tabContents[index]) {
            tabContents[index].style.display = "block";
          }
        });
      }
    });
  }
});

//card product variant hide /show
document.addEventListener('click', function (e) {
  const toggle = e.target.closest('.variant-toggle');
  if (toggle) {
    e.preventDefault();
    e.stopPropagation();

    const card = toggle.closest('.card-wrapper');
    if (!card) return;

    const variants = card.querySelector('.product-variants');
    if (!variants) return;

    const isOpen = !variants.hasAttribute('hidden');
    document.querySelectorAll('.product-variants').forEach(v => {
      v.setAttribute('hidden', '');
    });

    if (!isOpen) {
      variants.removeAttribute('hidden');
    }
    return;
  }
  if (e.target.closest('.variant-option')) {
    e.stopPropagation();
    return;
  }
  document.querySelectorAll('.product-variants:not([hidden])').forEach(v => {
    v.setAttribute('hidden', '');
  });
});

// pdp tab faq
const tabs = document.querySelectorAll('.tabs.custom-faq-tab ul li');

if (tabs.length > 0) {
  tabs.forEach(tab => {
    tab.addEventListener('click', function () {
      let target = this.getAttribute('data-href');
      target = target.replace('#', '');
      tabs.forEach(li => li.classList.remove('active'));
      document
        .querySelectorAll('.grid__item.tab-faq-section-inner .panel')
        .forEach(panel => panel.classList.remove('active'));

      this.classList.add('active');
      const matchedPanel = document.getElementById(target);

      if (matchedPanel) {
        matchedPanel.classList.add('active');
      }
    });
  });
}

// serach in mobile
(function () {
  const stopEvent = (e) => {
    const searchArea = e.target.closest('.search-modal__form');
    if (!searchArea) return;

    e.stopPropagation();
  };

  document.addEventListener('mousedown', stopEvent, true);
  document.addEventListener('click', stopEvent, true);
  document.addEventListener('pointerdown', stopEvent, true);
})();


const heading = document.querySelector('.table-contents .heading');
const content = document.querySelector('.table-contents .content');

if (heading && content) {
  heading.addEventListener('click', () => {
    content.classList.toggle('active');
  });
}

const listItems = document.querySelectorAll('.table-contents ul.menu li');

if (listItems.length && content) {
  listItems.forEach((li) => {
    li.addEventListener('click', () => {
      content.classList.remove('active');
    });
  });
}

document.addEventListener('DOMContentLoaded', function () {
  const carousel = document.querySelector('.jdgm-carousel-wrapper, .jdgm-carousel');

  if (!carousel) return;

  const review = carousel.querySelector('.jdgm-carousel-item, .jdgm-rev');

  if (!review) {
    const appBlock = carousel.closest('.shopify-block, .product__accordion, .product__info-container > *');

    if (appBlock) {
      appBlock.style.display = 'none';
    }
  }
});

//second mega menu hover
document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".mega-menu__left-image").forEach(function(menu){
    const links = menu.querySelectorAll(".mega-child-link");
    const images = menu.querySelectorAll(".mega-left-image");
    if (!links.length || !images.length) return;
    // First child active
    links[0].classList.add("active");
    images[0].style.display = "block";
    links.forEach(function(link){
      link.addEventListener("mouseenter", function(){
        const handle = this.dataset.child;
        links.forEach(l => l.classList.remove("active"));
        this.classList.add("active");
        images.forEach(function(image){
          if(image.dataset.left === handle){
            image.style.display = "block";
          }else{
            image.style.display = "none";
          }
        });
      });
    });
  });
});



// review home page js 
  const btn = document.querySelector('.js-read-more') || null;
  const hiddenBlocks = document.querySelectorAll('.testimonial-block-item.hidden') || null;
console.log("btn",btn,"hiddenBlocks",!hiddenBlocks.length)
  if (btn != "null" || hiddenBlocks != "null" ) {
      const moreText = btn.dataset.more;
      const lessText = btn.dataset.less;
    
      btn.addEventListener('click', () => {
        console.log("btn",btn);
        const isOpen = btn.classList.toggle('is-open');
    console.log("isOpen",isOpen);
        hiddenBlocks.forEach(block => {
          block.classList.toggle('hidden', !isOpen);
        });
    
        btn.textContent = isOpen ? lessText : moreText;
      });
  }

